import { ButtonState } from "./button-state";
import { table } from "../game/table";
import { Vector2 } from "../math/vector2";
class MouseSingleton {
  private buttonStates: ButtonState[] = [];
  private mousePosition: Vector2;
  private buttonPressedPosition: Vector2;

  public get position() {
    return Vector2.copy(this.mousePosition);
  }
  public get pressedPosition() {
    return Vector2.copy(this.buttonPressedPosition);
  }

  constructor() {
    // TODO to prevent context menu popup on right mouse click.
  }

  public init() {
    for (let i = 0; i < 3; i++) {
      this.buttonStates[i] = new ButtonState();
    }

    this.mousePosition = Vector2.zero;
 
    // handle mouse events
    document.addEventListener('mousemove', (event) =>
      this.handleMouseMove(event)
    );
    document.addEventListener('mousedown', (event) =>
      this.handleMouseDown(event)
    ); 
    document.addEventListener('mouseup', (event) => 
      this.handleMouseUp(event)
    );

    // handle touch events (for tablets)
    document.addEventListener('touchmove', (event) =>
      this.handleTouchMove(event)
    );
    document.addEventListener('touchstart', (event) =>
      this.handleTouchStart(event)
    );
    document.addEventListener('touchend', (event) => 
      this.handleTouchEnd(event)
    ); 
  }

  public onDistory() {
    // remove mouse events
    document.removeEventListener('mousemove', (event) =>
      this.handleMouseMove(event)
    );
    document.removeEventListener('mousedown', (event) =>
      this.handleMouseDown(event)
    );
    document.removeEventListener('mouseup', (event) =>
      this.handleMouseUp(event)
    );

    // remove touch events (for tablets)
    document.removeEventListener('touchmove', (event) =>
      this.handleTouchMove(event)
    );
    document.removeEventListener('touchstart', (event) =>
      this.handleTouchStart(event)
    );
    document.removeEventListener('touchend', (event) =>
      this.handleTouchEnd(event)
    ); 
  }

  public reset(): void {
    for (let i = 0; i < 3; i++) {
      this.buttonStates[i].pressed = false;
      this.buttonStates[i].released = false;
    }
  }

  public isDown(button: number): boolean {
    return this.buttonStates[button].down;
  }

  public isPressed(button: number): boolean {
    return this.buttonStates[button].pressed;
  }

  public isReleased(button: number): boolean {
    return this.buttonStates[button].released;
  }

  //
  // Handle mouse events.
  //
  private handleMouseMove(event: MouseEvent): void {
    const mouseX: number = (event.pageX - table.offsetX) / table.scaleX;
    const mouseY: number = (event.pageY - table.offsetY) / table.scaleY;
    this.mousePosition = new Vector2(mouseX, mouseY);
  }

  private handleMouseDown(event: MouseEvent) {
    this.buttonStates[event.button].down = true;
    this.buttonStates[event.button].released = false;
    this.buttonStates[event.button].pressed = true;
    this.buttonPressedPosition = this.mousePosition;
  }

  private handleMouseUp(event: MouseEvent) {
    this.buttonStates[event.button].down = false;
    this.buttonStates[event.button].released = true;
  }

  //
  // Handle touch events (for tablets).
  //
  private handleTouchMove(event: TouchEvent): void {
    const mouseX: number = (event.targetTouches[0].pageX - table.offsetX) / table.scaleX;
    const mouseY: number = (event.targetTouches[0].pageY - table.offsetY) / table.scaleY;
    this.mousePosition = new Vector2(mouseX, mouseY);
  }

  private handleTouchStart(event: TouchEvent) {
    if (event.targetTouches.length > 1) {
      this.buttonStates[0].down = true;
      this.buttonStates[0].released = false;
      this.buttonStates[0].pressed = true;
      this.buttonPressedPosition = this.mousePosition;
    }
  }

  private handleTouchEnd(event: TouchEvent) {
    this.buttonStates[0].down = false;
    this.buttonStates[0].released = true;
  }
}

export const Mouse = new MouseSingleton();
